import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const STUDENT_GAP_ROUTE = {
  name: 'studentgap/:studentId/:logicalErrorId',
  route(classId: string, studentId: string, logicalErrorId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'studentgap', studentId, logicalErrorId];
  }
};